(() => {
  if (customElements.get('subinats-product-price')) return;
  class SubinatsProductPrice extends HTMLElement {
    connectedCallback() {
      this.expire = () => {
        if (Date.now() < Date.parse(this.dataset.endsAt)) return;
        this.querySelector('[data-subinats-product-offer]').hidden = true;
        this.querySelector('[data-subinats-product-standard]').hidden = false;
        const amount = this.querySelector('[data-subinats-afterpay-price]');
        if (amount.textContent !== this.dataset.baseAmount) amount.textContent = this.dataset.baseAmount;
      };
      this.expire();
      const remaining = Date.parse(this.dataset.endsAt) - Date.now();
      if (remaining > 0) this.timer = window.setTimeout(this.expire, Math.min(remaining, 2147483647));
      window.addEventListener('pageshow', this.expire);
      document.addEventListener('visibilitychange', this.expire);
    }
    disconnectedCallback() {
      window.clearTimeout(this.timer);
      window.removeEventListener('pageshow', this.expire);
      document.removeEventListener('visibilitychange', this.expire);
    }
  }
  customElements.define('subinats-product-price', SubinatsProductPrice);
})();

